import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  styled,
} from '@mui/material';
import { motion } from 'framer-motion';

// 1. Import your local images here
import researchAssistantImage from '../images/research-assistant-ai.jpg';
import mediGuidImage from '../images/mediguid-nyc.jpg';
import careerQuestImage from '../images/careerquest.jpg';
import bankInsightImage from '../images/bankinsight.jpg';
import metroExamsImage from '../images/metroexams.jpg';
import medicalPlatformImage from '../images/medical-platform.jpg';
import zeroCrateImage from '../images/zerocrate.jpg';

// Data for your projects
const projects = [
  {
    title: 'Research Assistant AI',
    description: 'Full-stack AI-powered data management platform',
    imageUrl: researchAssistantImage,
    projectLink: 'https://research-assistant-tims-projects-d59677e7.vercel.app/',
  },
  {
    title: 'MediGuid NYC',
    description: 'AI symptom checker with local health resources',
    imageUrl: mediGuidImage,
    projectLink: 'https://mediguid-nyc.vercel.app/',
  },
  {
    title: 'CareerQuest',
    description: 'Personalized career discovery platform',
    imageUrl: careerQuestImage,
    projectLink: 'https://career-quest-virid.vercel.app/',
  },
  {
    title: 'BankInsight',
    description: 'Financial comparison tool',
    imageUrl: bankInsightImage,
    projectLink: 'https://banking-summarizer.vercel.app/',
  },
  {
    title: 'MetroExams',
    description: 'find and explore various exams across New York City.',
    imageUrl: metroExamsImage,
    projectLink: 'https://metro-exams.vercel.app/',
  },
  {
    title: 'Medical Practice Web Platform',
    description: 'medical clinic.',
    imageUrl: medicalPlatformImage,
    projectLink: 'https://my-medical-app-pied.vercel.app/',
  },
  {
    title: 'ZeroCrate',
    description: 'AI-powered solutions for fresh grocery.',
    imageUrl: zeroCrateImage,
    projectLink: 'https://zerocrate-website.vercel.app/',
  },
];

const StyledPortfolioSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.background.paper,
}));

// Define animation variants for the cards
const cardVariants = {
  offscreen: {
    y: 50,
    opacity: 0
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 1
    }
  }
};

const PortfolioSection = () => {
  return (
    <StyledPortfolioSection>
      <Container maxWidth="lg">
        <Typography variant="h3" component="h2" align="center" fontWeight="bold" gutterBottom>
          Portfolio / Projects
        </Typography>
        <Typography variant="h6" align="center" color="text.secondary" paragraph>
          Here are a few examples of websites I’ve built:
        </Typography>

        <Grid container spacing={4} sx={{ mt: 4 }} justifyContent="center">
          {projects.map((project, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={cardVariants}
              >
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={project.imageUrl}
                    alt={project.title}
                    sx={{ objectFit: 'cover' }}
                  />
                  <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: 120 }}>
                    <Typography gutterBottom variant="h5" component="div" fontWeight="bold">
                      {project.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {project.description}
                    </Typography>
                    <Box sx={{ mt: 'auto', textAlign: 'right' }}>
                      <Button
                        variant="text"
                        color="secondary"
                        size="small"
                        href={project.projectLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Project
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            href={'https://prezxvii.github.io/Portfolio/#contact'}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Full Portfolio
          </Button>
        </Box>
      </Container>
    </StyledPortfolioSection>
  );
};

export default PortfolioSection;